import "./tarifsTextDeroulement.css";

import TarifsTextCartouche from "./tarifsTextCartouche";

function TarifsTextDeroulement({ operations = [] }) {
  const content = (
    <div className="tarifs-text-deroulement-contenair">
      <div className="tarifs-text-deroulement-title">
        Déroulement de la prestation
        <br />
        <div className="tarifs-text-deroulement-separator-contenair">
          <div className="tarifs-text-deroulement-separator"></div>
        </div>
      </div>
      <div className="tarifs-text-deroulement-list">
        {operations.map((item, index) => (
          <span key={index}>{formatText(item)}</span>
        ))}
      </div>
    </div>
  );
  return <TarifsTextCartouche bLeft="10px">{content}</TarifsTextCartouche>;
}

function formatText(input) {
  // On sépare le texte au niveau du ":"
  let [part1, part2] = input.split(":");
  if (part2 === "" || part2 === undefined) {
    return <p>{part1}</p>;
  }

  // On retourne la chaîne avec la balise <strong> autour de la première partie
  return (
    <p>
      <b style={{ fontWeight: "700", fontSize: "17px" }}>{part1}</b> : {part2}
    </p>
  );
}

export default TarifsTextDeroulement;
